module.exports = __webpack_public_path__ + "img/7341e69.jpg";